<template>
  <div>
    <page-title></page-title>
    <transition name="fade" mode="out-in">
      <div v-if="cardType==='list'" class="card bg-dark" key="list">
        <div class="card-body">
          <div class="table-header">
            <form>
              <div class="form-row">
                <div class="col-md-3 col-12 my-1">
                  <div class="dropdown  mr-md-2 mr-sm-0">
                    <button class="btn btn-secondary btn-block dropdown-toggle" type="button" id="dropdownMenuButton"
                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      {{search.q?search.q:'用户操作日志'}}
                    </button>
                    <div class="dropdown-menu bg-dark" aria-labelledby="dropdownMenuButton">
                      <template v-for="item in actions">
                        <h6 class="dropdown-header">{{item.model}}</h6>
                        <button @click="selectAction(action)" v-for="action in item.payload" type="button"
                                class="dropdown-item">{{action}}
                        </button>
                      </template>
                      <div class="dropdown-divider"></div>
                      <button @click="selectAction('')" type="button" class="dropdown-item">全部操作</button>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 col-12 my-1 date-picker">
                <el-date-picker
                  class="form-control  "

                  v-model="search.time"
                  type="datetimerange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
                </div>

                <div class="col-md-2 col-12 my-1">
                <label class="sr-only">用户名</label>
                <input v-model="search.name" type="text" class="form-control form-control mr-md-2 mr-sm-0"
                       placeholder="搜索用户名">
                </div>
                <div class="col-md-2 col-12 my-1">
                <button @keyup.enter="loadLogs('SEARCH')" @click="loadLogs('SEARCH')" type="button" class="btn btn btn-primary btn-block" >搜索</button>
                </div>
              </div>
            </form>
          </div>
          <div v-if="loading">
            <loading></loading>
          </div>
          <div class="table-responsive" v-else>
            <table class="table table-leemma ">
              <thead>
              <tr>
                <th>时间</th>
                <th>所属公司</th>
                <th>操作账号</th>
                <th>执行操作</th>
                <th>备注</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="log in logs">
                <td>{{Moment(log.created_at).format('YYYY-MM-DD HH:mm:ss')}}</td>
                <td>{{log.company}}</td>
                <td>{{log.account}}</td>
                <td>{{log.action}}</td>
                <td>{{log.remark}}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <page :page-no="search.page_no" :pageSize="search.page_size" :count="search.count" @click="a"></page>

        </div>
      </div>

    </transition>
  </div>

</template>

<script>
  import pageTitle from '@/components/pageTitle'
  import page from '@/components/pagination'
  import Moment from 'moment'

  export default {
    name: 'logs',
    components: {
      pageTitle,
      page
    },
    data() {
      return {
        Moment,
        cardType: 'list',
        logs: [],
        actions: [],
        loading: false,
        search: {
          q: '',
          time: [],
          page_no: 1,
          page_size: 15,
          count: 0,
          name: ''
        }
      }
    },
    computed: {
      searchEnd() {
      }

    },
    created() {
      this.loadLogs();
      if (this.$route.query.type === 'list') {
        this.cardType = 'list'
      }
    },
    methods: {
      a(a) {
        console.log(a)
        this.search.page_no = a
        this.loadLogs()
      },
      loadLogs(type) {
        this.loading = true;
        if (type === 'SEARCH') {
          this.search.page_no = 1
        }
        let s = this.search,
          url = 'logs',
          params = {
            auth_token: 'default',
            page_no: s.page_no,
            page_size: s.page_size,
            begin: s.time[0],
            end: s.time[1],
            q: s.q,
            name: s.name
          };

        this.$http.get(url, {params}).then(data => {
          this.loading = false;
          if (data.status_code === 'SUCCEEDED') {
            this.logs = data.logs;
            this.search.count = data.total;
            this.actions = data.actions;
          }
        })
      },
      selectAction(action) {
        this.search.q = action;
        this.loadLogs('SEARCH')
      }
    }

  }
</script>

<style type="scss" scoped>
  .fade-enter-active, .fade-leave-active {
    transition: all .3s
  }

  .fade-enter {
    opacity: 0;
    transform: translateX(-10px);
  }

  .fade-leave-to {
    opacity: 0;
    transform: translateX(10px);
  }

  .drop-menu {
    background: #333B54;
    color: #fff;
  }

  .bg-dark .dropdown-item {
    color: #fff;
  }

  .bg-dark .dropdown-item:hover {
    color: #000;
  }

  .dropdown-header {
    color: #03A7F3;
    margin-left: -10px;
    font-weight: 100;
    line-height: 30px;
    font-size: 14px;
  }
.date-picker .form-control{
  width: 100%;
}

</style>
<style>
  .table-header .el-date-editor .el-range-input {
    background: #333B54;
    color: #ffffff;
  }
</style>



// WEBPACK FOOTER //
// src/view/logs.vue